function getTabElement(button, dataAttribute) {
    const tabId = button.getAttribute('data-tab-button'),
          groupId = button.getAttribute('data-tab-group');

    if (tabId && groupId) {
        return document.querySelector(`[data-tab-group="${groupId}"][${dataAttribute}="${tabId}"]`);
    }

    return null;
}

function getExtraNavContent(button) {
    return getTabElement(button, 'data-tab-extra-nav-content');
}

function getContent(button) {
    return getTabElement(button, 'data-tab-content');
}

function activateTab(button) {
    const content = getContent(button),
          extraNavContent = getExtraNavContent(button);

    button.classList.add('pvTabs__button--active');

    if (content) {
        content.classList.add('pvTabs__content--active');
    }

    if (extraNavContent) {
        extraNavContent.classList.add('pvTabs__extraNavContent--active');
    }
}

function deactivateTab(button) {
    const content = getContent(button),
          extraNavContent = getExtraNavContent(button);

    button.classList.remove('pvTabs__button--active');

    if (content) {
        content.classList.remove('pvTabs__content--active');
    }

    if (extraNavContent) {
        extraNavContent.classList.remove('pvTabs__extraNavContent--active');
    }
}

function handleClick(button, buttons) {
    activateTab(button);
    buttons.filter(btn => btn !== button).forEach(deactivateTab);
}

function init() {
    const buttons = [...document.querySelectorAll('.js_pvTabs__button')];

    buttons.forEach(button => button.addEventListener('click', e => handleClick(button, buttons)));
}

$(document).ready(init);
